import type { HarnessPendingToolCall } from '../types'
import { executeOrderListTool } from './order-list'
import { executeProductionRecordsTool } from './production-records'
import type { ClientToolExecution } from './types'

export type ClientToolCardKind = 'order-import' | 'production-history'

export interface ClientToolDefinition {
  execute: ClientToolExecutor
  kind: ClientToolCardKind
  messageIdPrefix: string
  failureMessage: string
}

export type ClientToolExecutor = (
  toolCall: HarnessPendingToolCall
) => Promise<ClientToolExecution>

export const CLIENT_TOOL_REGISTRY: Record<string, ClientToolDefinition> = {
  get_material_export_records: {
    execute: executeProductionRecordsTool,
    kind: 'production-history',
    messageIdPrefix: 'production',
    failureMessage: '生产文件记录查询失败',
  },
  get_order_list: {
    execute: executeOrderListTool,
    kind: 'order-import',
    messageIdPrefix: 'order-import',
    failureMessage: '订单查询失败',
  },
}

export function createUnsupportedClientToolResult(
  toolCall: HarnessPendingToolCall
): ClientToolExecution {
  return {
    toolCallId: toolCall.toolCallId,
    resultForAgent: {
      ok: false,
      error: {
        code: 'UNSUPPORTED_CLIENT_TOOL',
        message: `前端暂不支持执行 Tool：${toolCall.name}`,
      },
    },
  }
}
export async function executeClientTool(
  toolCall: HarnessPendingToolCall
): Promise<ClientToolExecution> {
  const definition = CLIENT_TOOL_REGISTRY[toolCall.name]
  if (!definition) {
    throw new Error(`暂不支持前端执行 Tool：${toolCall.name}`)
  }
  return definition.execute(toolCall)
}

export type {
  ClientToolExecution,
  OrderListToolData,
  ProductionHistoryToolData,
} from './types'
